import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { ICategory } from 'src/app/interfaces/category';
import { BehaviorSubject, Subscription as RxSubscription } from 'rxjs';

import { CategoryApiService } from './category-api-service';
import { PageEvent } from '@angular/material/paginator';
import { ApiDataSource } from 'src/app/services/api-data-source.service';
import { IResponseBody } from 'src/app/interfaces/response-body';
import { Category } from 'src/modules/event/interfaces/category';

export class CategoryDataSource extends ApiDataSource {
  [x: string]: any;
  public loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public Category: BehaviorSubject<any> = new BehaviorSubject([]);
  public Subscriptions: RxSubscription[] = [];
  protected Data: BehaviorSubject<Category[]> = new BehaviorSubject([]);

  constructor(
    public CategoryApi: CategoryApiService,
    private readonly role: string,
    protected listingId?: number,
    private localOffer?: boolean
  ) {
    super();
  }

  protected loadData(PageEvent: PageEvent) {
    return this.CategoryApi.listWithPageEvent(this.role, this.filter.value, {
      ...PageEvent,
    });
  }

  protected setData(ResponseBody: IResponseBody) {
    this.Data.next(ResponseBody.data);
  }

  public load() {
    this.loading.next(true);
    if (this.listingId) {
      this.CategoryApi.list(this.role, this.listingId, this.localOffer).then(
        (data) => {
          this.Category.next(data);
          this.loading.next(false);
        },
        (error) => this.loading.next(false)
      );
    }
  }

  public getAllCategories() {
    // this.loading.next(true);
    // this.CategoryApi.getAllCategories(this.DataSourceConfig.role).then(
    //   (data: ICategory[]) => {
    //     this.Category.next(data);
    //     this.loading.next(false);
    //   },
    //   (error) => this.loading.next(false)
    // );
  }
  public save(Category: ICategory) {
    return this.CategoryApi.save(
      this.role,
      this.listingId,
      Category,
      this.localOffer
    ).then((result) => {
      this.load();
      return result;
    });
  }

  public delete(Category: ICategory) {
    return this.CategoryApi.delete(
      this.role,
      this.listingId,
      Category,
      this.localOffer
    ).then(() => this.load());
  }

  public disconnect(collectionViewer?: CollectionViewer) {
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }
}
